import React from 'react';
import { useSelector } from 'react-redux';
import { MultiSelectFilter } from './MultiSelectFilter';
import { peopleOptions } from './peopleOptions';

/**
 * DSO manager filter (multi-select). Writes the `dsoManager` filter key.
 *
 * Unlike its RAM siblings this one does not fetch: the DSO manager list comes
 * from the auth-service role query that `useAppBootstrap` dispatches, not from
 * `admin/rams-dsomanagers`. A guard here would also fire before the shell's
 * bootstrap — child effects run before parent effects — and double-request it.
 */
export const DsoManagerFilter = ({ filter, handleFilterChange }) => {
  const dsoManagers = useSelector((state) => state.users.dsoManagers);

  return (
    <MultiSelectFilter
      label="DSO Manager"
      options={peopleOptions(dsoManagers)}
      value={filter?.dsoManager}
      onChange={(value) => handleFilterChange('dsoManager', value)}
      optionsWidth={180}
    />
  );
};

export default DsoManagerFilter;
